import Vue from "vue"
import VueTailwind from "vue-tailwind"

const settings = {}

Vue.use(VueTailwind, settings)
